export const safe = (value, fallback = "Data Not Available") => {
  return value === undefined || value === null || value === "" ? fallback : value;
};

export const formatSleep = (seconds) => {
  if (!seconds) return "--";

  const hrs = Math.floor(seconds / 3600);
  const mins = Math.floor((seconds % 3600) / 60);

  return `${hrs}h ${mins}m`;
};
